<style scoped>
.logo {
  max-height: 180px;
  max-width: 180px;
  margin-bottom: 0px;
}
.wrapper {
  margin-top: -40px;
}
</style>

<template>

<v-layout class="wrapper">
    <v-flex v-if="content" xs12 class="mx-auto">
      <v-flex xs12>
        <v-layout row wrap justify-center>
          <v-img :src="`../images/logo.svg`" class="transparent logo pointer mx-auto" @click="$router.push('/')"></v-img>
        </v-layout>
      </v-flex>
      <v-card v-if="!success" class="px-2 py-2 text-xs-center" flat color="transparent">
          <h1 class="display-2 mb-2">{{content.title}}</h1>
          <loading v-if="loading" style="width:100px; height:100px" />
          <v-form @submit.prevent="login" ref="form">
              <v-flex xs12 md8 class="mx-auto">
                  <span style="color:red" v-if="loginErr">{{content.validation.login}}</span>
              </v-flex>
              <v-layout xs12 d-flex row wrap justify-space-around>
                  <v-flex xs12 sm5>
                      <v-text-field color="green" v-model="form.first_name" :label="content.fname" type="text" :rules="[rules.fname]"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                      <v-text-field color="green" v-model="form.last_name" :label="content.lname" type="text" :rules="[rules.lname]"></v-text-field>
                  </v-flex>
              </v-layout>
              <v-layout xs12 d-flex row wrap justify-space-around>
                  <v-flex xs12 sm5>
                      <v-text-field color="green" v-model="form.email" :label="content.email" :error-messages="errors && errors.email ? errors.email : ''" type="email" :rules="[rules.email]"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                      <v-text-field color="green" v-model="form.email_confirmation" :label="content.cemail" type="email" :rules="[rules.cemail, rules.cemailCheck]"></v-text-field>
                  </v-flex>
              </v-layout>
              <v-layout xs12 d-flex row wrap justify-space-around>
                  <v-flex xs12 sm5>
                      <v-text-field color="green" autocomplete="new-password" v-model="form.password" :label="content.password" :type="showP1 ? 'text' : 'password'" :rules="[rules.password, rules.password_between]" :append-icon="form.password ? (showP1 ? 'visibility' : 'visibility_off') : 'undefined'"
                      @click:append="showP1 = !showP1" @keyup="passStrength()" @blur="psStatus = false"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                      <v-text-field color="green" autocomplete="new-password" v-model="form.password_confirmation" :label="content.cpassword" :type="showP2 ? 'text' : 'password'" :rules="[rules.cpassword]" :append-icon="form.password_confirmation ? (showP2 ? 'visibility' : 'visibility_off') : 'undefined'"
                      @click:append="showP2 = !showP2"></v-text-field>
                  </v-flex>
              </v-layout>
              <v-flex xs12 v-if="psStatus">
                  <v-progress-linear v-model="passwordStrength" :color="psColor" height="20" reactive class="white--text">{{psValue}}</v-progress-linear>
              </v-flex>
              <v-layout row wrap justify-center class="mt-2">
                <v-flex xs12 sm8 md6>
                  <v-btn dark color="blue" type="submit" block>{{content.title}}</v-btn>
                </v-flex>
              </v-layout>
          </v-form>
          <v-layout justify-center wrap>
              <router-link to="/login" style="text-decoration:none">
                  <v-btn flat>{{content.signin}}</v-btn>
              </router-link>
          </v-layout>
      </v-card>
      <v-card v-else class="px-2 py-2 text-xs-center" flat color="transparent">
        <h1 class="blue--text display-2">{{content.success.message}}!</h1>
        <h3>{{content.success.redirect}} {{success}} {{content.success.seconds}}</h3>
      </v-card>
      <Language/>
    </v-flex>
</v-layout>

</template>

<script>

import Loading from "../General/loading";
import Language from '../tools/language';
export default {
    components: { Loading, Language },
    data() {
        return {
            form: {
                client_id: 2,
                client_secret: "dXccV61flMlRyfxIPnOpvB4DC9ZE2CaXq9wUekfZ",
                grant_type: "password",
                email: null,
                email_confirmation: null,
                password: null,
                password_confirmation: null,
                first_name: null,
                last_name: null,
            },
            psStatus: false,
            passwordStrength: 0,
            psColor: 'red',
            psValue: '',
            content: {},
            loading: false,
            rules: {
                email: v => /.+@.+\..+/.test(v) || this.content.validation.email,
                cemail: v => /.+@.+\..+/.test(v) || this.content.validation.email,
                cemailCheck: v => v == this.form.email || this.content.validation.emailMatch,
                password: v => !!v || this.content.validation.password,
                password_between: v => (!!v && v.length >= 6 && v.length <= 18) || this.content.validation.password_between,
                cpassword: v => v == this.form.password || this.content.validation.cpassword,
                fname: v => !!v || this.content.validation.fname,
                lname: v => !!v || this.content.validation.lname
            },
            loginErr: false,
            showP1: false,
            showP2: false,
            locale: null,
            errors: {},
            success: null,
        };
    },
    created() {
        this.locale = Lang.get();
        this.setLang();
    },
    methods: {
        login() {
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    axios
                        .post("/api/signup", this.form)
                        .then(res => {
                          this.loading = false;
                          // this.$router.push("/");
                          this.success = 5
                          let interval = setInterval(() => {
                            this.success -= 1
                            if (this.success == 0) {
                              clearInterval(interval);
                              this.$router.push("/");
                            }
                          }, 1000);
                        })
                        .catch(err => {
                          if (err.response.data.errors) {
                            if (err.response.data.errors.email) {
                              if (err.response.data.errors.email[0] === 'The email has already been taken.') {
                                this.errors.email = this.content.validation.emailTaken;
                              }
                            }
                          }
                          this.loading = false;
                        });
                }
            },
            passStrength() {
              let password = this.form.password;
              let strength = 0;
              if (!password || password.length < 1) {
                this.psStatus = false;
              } else if(password && password.length > 0) {
                if (password.length < 6) {
                  this.passwordStrength = 25;
                  this.psValue = this.content.psLevel[0];
                  this.psColor = 'red';
                } else {
                  strength += 1;
                  if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)){
                    strength += 1;
                  }
                  if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)){
                    strength += 1;
                  }
                  if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)){
                    strength += 1;
                  }
                  if (password.match(/(.*[!,%,&,@,#,$,^,*,?,_,~].*[!,%,&,@,#,$,^,*,?,_,~])/)){
                    strength += 1;
                  }
                  if (strength < 2 ) {
                    this.passwordStrength = 50;
                    this.psValue = this.content.psLevel[1];
                    this.psColor = 'amber';
                  } else if (strength == 2 ) {
                    this.passwordStrength = 75;
                    this.psValue = this.content.psLevel[2];
                    this.psColor = 'blue';
                  } else {
                    this.passwordStrength = 100;
                    this.psValue = this.content.psLevel[3];
                    this.psColor = 'green accent-4';
                  }
                }
                this.psStatus = true;
              }
            },
            setLang() {
                if (this.locale == "en") {
                    this.content = {
                        title: "Sign Up",
                        signin: "Sign In",
                        fname: "First Name",
                        lname: "Last Name",
                        email: "Email Address",
                        cemail: "Email Address Confirmation",
                        password: "Password",
                        cpassword: "Password Confirmation",
                        signup: "Signup",
                        forgot_pass: "Forgot Password",
                        validation: {
                            email: "Must type an Email Address",
                            emailMatch: "The Email Addresses Are Not Matched",
                            emailTaken: "The Email has already been taken",
                            fname: "First name is required",
                            lname: "Last name is required",
                            password: "Password is required",
                            password_between: "Password must be between 6 to 18 characters",
                            cpassword: "The Passwords does not match",
                            login: "Email or Password is incorrect"
                        },
                        psLevel: [
                          'Too Weak',
                          'Weak',
                          'Not Bad...',
                          'Excellent!',
                        ],
                        success: {
                          message: 'You have been registered successfully',
                          redirect: 'redirect in',
                          seconds: 'seconds',
                        }
                    };
                } else if (this.locale == "he") {
                    this.content = {
                        title: "הירשם",
                        signin: "התחבר",
                        fname: "שם פרטי",
                        lname: "שם משפחה",
                        email: "כתובת אימייל",
                        cemail: "אישור כתובת אימייל",
                        password: "סיסמא",
                        cpassword: "אישור סיסמא",
                        signup: "הירשם",
                        forgot_pass: "שכחתי סיסמא",
                        validation: {
                            email: "חובה להזין כתובת אימייל",
                            emailTaken: "כתובת האימייל כבר תפוסה",
                            fname: "חובה להזין שם פרטי",
                            lname: "חובה להזין שם משפחה",
                            password: "חובה להזין סיסמא",
                            password_between: "הסיסמא חייבת להיות בין 6 ל-18 תווים",
                            cpassword: "הסיסמאות אינן תואמות",
                            login: "כתובת אימייל או סיסמא אינו נכון"
                        },
                        psLevel: [
                          'חלשה מידי',
                          'חלשה',
                          'לא רע...',
                          'מעולה!',
                        ],
                        success: {
                          message: 'נרשמת למערכת בהצלחה',
                          redirect: 'תועבר בתוך',
                          seconds: 'שניות',
                        }
                    };
                }
            }
    }
};

</script>
